import { ChangeEvent, FC, Fragment, useRef } from "react";
import { Button } from "@mui/material";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import { styled } from "@mui/material/styles";

const InputFileHidden = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

interface FileUploaderProps {
  onFileUpload: (file: File) => void;
}

export const FileUploader: FC<FileUploaderProps> = ({ onFileUpload }) => {
  const hiddenFileInput = useRef<HTMLInputElement>(null);
  const handleClick = () => {
    if (hiddenFileInput.current) {
      hiddenFileInput.current.click();
    }
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;

    const fileUploaded = files[0];
    onFileUpload(fileUploaded);
  };
  return (
    <Fragment>
      <Button
        onClick={handleClick}
        component="label"
        variant="contained"
        startIcon={<DocumentScannerIcon />}
        fullWidth
      >
        Selecionar documento
        <InputFileHidden
          type="file"
          onChange={handleFileChange}
          accept="application/pdf"
        />
      </Button>
    </Fragment>
  );
};
